import { EditSquare, Help } from '@project-lary/react-material-symbols';
import IconComponent from 'gcs-common/components/Icon/Icon';
import FeatureFlagProtectedRoute from 'gcs-common/components/ProtectedRoutes/FeatureFlagProtectedRoute';
import { ICON } from 'gcs-common/constants/IconConstants';
import { CHAT_ROUTES } from 'gcs-common/constants/routes';
import IconButton from 'gcs-common/design-system/ui/icon-button';
import FEATURE_FLAGS from 'gcs-common/helper/featureFlagsHelper';
import { getCurrentFriendlyName, getIsAgent } from 'gcs-common/slices/currentUser/currentUserSelectors';
import { getHasFeatureFlag } from 'gcs-common/slices/currentUser/currentUserSelectors';
import { getIsOnline } from 'gcs-common/slices/offline/offlineSelectors';
import { getFavicon } from 'gcs-common/slices/theme/themeSelectors';
import { getSidebarCollapsed } from 'gcs-common/slices/uiState/uiStateSelectors';
import { useCallback, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import { useLocation } from 'react-router-dom';
import openHelp from '../../slices/settings/settingsThunks/openHelp';
import AnimatedSidebarButton from '../AnimatedSidebarButton/AnimatedSidebarButton';
import CurrentUserImage from '../CurrentUserImage/CurrentUserImage';
import styles from './styles.module.scss';

const NavBar = () => {
  const isAgent = useSelector(getIsAgent);
  const friendlyName = useSelector(getCurrentFriendlyName);
  const sidebarCollapsed = useSelector(getSidebarCollapsed);
  const logo = useSelector(getFavicon);
  const location = useLocation();
  const { pathname } = location;
  const showCreateTicket = pathname.startsWith(CHAT_ROUTES.TICKETS);
  const isOnline = useSelector(getIsOnline);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const onOpenHelp = useCallback(() => {
    dispatch(openHelp());
  }, [dispatch]);

  const goToNewTicket = () => {
    navigate(CHAT_ROUTES.NEW_TICKET);
  };

  const body = useMemo(() => {
    if (sidebarCollapsed) {
      return <CurrentUserImage isAgent={isAgent} />;
    }
    return (
      <>
        {isAgent && <img src={logo} className={styles.agentLogoIcon} alt="Firmenlogo" />}
        <CurrentUserImage isAgent={isAgent} />
        <div className={`${isAgent ? styles.userDetails : styles.userCraftsmanDetails} w-full`}>
          <div className="flex w-full items-center justify-between">
            <div className="flex-1" data-testid="myusername">
              {friendlyName}
            </div>
            {!isAgent && showCreateTicket && (
              <div className="ml-auto">
                <IconButton
                  Icon={EditSquare}
                  iconSize="size-6"
                  className="cursor-pointer"
                  size="m"
                  variant="ghost_neutral"
                  onClick={() => goToNewTicket()}
                />
              </div>
            )}
          </div>
        </div>
        {isAgent && (
          <div className={styles.wrapper}>
            <FeatureFlagProtectedRoute disabledFlag={FEATURE_FLAGS.SUPPORT_PAGE_DISABLED}>
              <IconButton
                Icon={Help}
                iconSize="size-6"
                className="cursor-pointer"
                size="m"
                variant="ghost_neutral"
                alt="feedback"
                disabled={!isOnline}
                onClick={() => onOpenHelp()}
              />
            </FeatureFlagProtectedRoute>
          </div>
        )}
      </>
    );
  }, [sidebarCollapsed, isAgent, logo, friendlyName, onOpenHelp, isOnline, showCreateTicket]);

  return (
    <div
      className={`${isAgent ? styles.userDetailsContainer : styles.craftsmanDetailsContainer} border-0 border-neutral-7 border-b border-solid`}
    >
      {body}
    </div>
  );
};

NavBar.propTypes = {};

export default NavBar;
